import { render, staticRenderFns } from "./WorkflowLayout.vue?vue&type=template&id=adf78792"
import script from "./WorkflowLayout.vue?vue&type=script&lang=js"
export * from "./WorkflowLayout.vue?vue&type=script&lang=js"
import style0 from "./WorkflowLayout.vue?vue&type=style&index=0&id=adf78792&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports